import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import styles from './FinalConfirmationModal.module.css';

const FinalConfirmationModal = ({ onClose }) => {
  const { t } = useTranslation();

  return (
    <motion.div
      className={styles.modalOverlay}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.div
        className={styles.modalContent}
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
        transition={{ duration: 0.2 }}
      >
        <h2 className={styles.modalTitle}>{t('account_marked_for_deletion')}</h2>
        <p className={styles.modalText}>
          {t('account_deletion_warning')}
        </p>
        <button onClick={onClose} className={styles.closeButton}>
          {t('close')}
        </button>
      </motion.div>
    </motion.div>
  );
};

export default FinalConfirmationModal;
